// extracted by mini-css-extract-plugin
export default {"ERROR":"Message_ERROR__Ul1z5","SUCCESS":"Message_SUCCESS__DZ3vo"};